<div
  class="min-h-screen flex items-center justify-center  py-12 px-4 sm:px-6 lg:px-8"
>
  <div class="max-w-5xl w-full flex rounded-xl shadow-lg overflow-hidden">
    <!-- Login Form Section -->
    <div class="w-full md:w-1/2 bg-white dark:bg-gray-800 p-8 sm:p-12">
      <div class="flex justify-center mb-6">
        <img
          class="h-16 w-auto dark:hidden"
          src="assets/logo/Logo.svg"
          alt="GraveNew Logo"
        />
        <img
          class="h-16 w-auto hidden dark:block"
          src="assets/logo/Logo-white.svg"
          alt="GraveNew Logo"
        />
      </div>

      <h2
        class="mt-2 text-center text-3xl font-extrabold text-gray-900 dark:text-gray-100"
        translate="LOGIN.TITLE"
      ></h2>

      <form
        [formGroup]="loginForm"
        (ngSubmit)="onSubmit()"
        class="mt-8 space-y-6"
      >
        <div class="rounded-md space-y-4">
          <div>
            <label
              for="username"
              class="block text-sm font-medium text-gray-700 dark:text-gray-300"
              translate="LOGIN.USERNAME"
            >
            </label>
            <div class="mt-1">
              <input
                id="username"
                name="username"
                type="text"
                formControlName="username"
                class="appearance-none block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-arabic-green focus:border-arabic-green dark:bg-gray-700 dark:text-gray-200 sm:text-sm"
                [ngClass]="{
                  'border-red-500':
                    loginForm.get('username')?.invalid &&
                    loginForm.get('username')?.touched
                }"
                [placeholder]="'LOGIN.USERNAME_PLACEHOLDER' | translate"
              />
              <div
                *ngIf="
                  loginForm.get('username')?.invalid &&
                  loginForm.get('username')?.touched
                "
                class="mt-1 text-xs text-red-500"
              >
                <span
                  *ngIf="loginForm.get('username')?.errors?.['required']"
                  translate="LOGIN.USERNAME_REQUIRED"
                >
                </span>
              </div>
            </div>
          </div>

          <div>
            <div class="flex items-center justify-between">
              <label
                for="passwordHash"
                class="block text-sm font-medium text-gray-700 dark:text-gray-300"
                translate="LOGIN.PASSWORD"
              >
              </label>
              <!-- <a
                href="#"
                class="text-sm font-medium text-arabic-green hover:text-arabic-green-dark dark:text-arabic-green-light dark:hover:text-arabic-green"
                translate="LOGIN.FORGOT_PASSWORD"
              >
              </a> -->
            </div>
            <div class="mt-1">
              <input
                id="passwordHash"
                name="passwordHash"
                type="password"
                formControlName="passwordHash"
                class="appearance-none block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-arabic-green focus:border-arabic-green dark:bg-gray-700 dark:text-gray-200 sm:text-sm"
                [ngClass]="{
                  'border-red-500':
                    loginForm.get('passwordHash')?.invalid &&
                    loginForm.get('passwordHash')?.touched
                }"
                [placeholder]="'LOGIN.PASSWORD_PLACEHOLDER' | translate"
              />
              <div
                *ngIf="
                  loginForm.get('passwordHash')?.invalid &&
                  loginForm.get('passwordHash')?.touched
                "
                class="mt-1 text-xs text-red-500"
              >
                <span
                  *ngIf="loginForm.get('passwordHash')?.errors?.['required']"
                  translate="LOGIN.PASSWORD_REQUIRED"
                >
                </span>
                <span
                  *ngIf="loginForm.get('passwordHash')?.errors?.['minlength']"
                  translate="LOGIN.PASSWORD_LENGTH"
                >
                </span>
              </div>
            </div>
          </div>

          <!-- <div class="flex items-center">
            <input
              id="remember-me"
              name="remember-me"
              type="checkbox"
              formControlName="rememberMe"
              class="h-4 w-4 text-arabic-green focus:ring-arabic-green border-gray-300 dark:border-gray-600 rounded"
            />
            <label
              for="remember-me"
              class="ml-2 block text-sm text-gray-900 dark:text-gray-300"
              translate="LOGIN.REMEMBER_ME"
            >
            </label>
          </div> -->
        </div>

        <div>
          <button
            type="submit"
            [disabled]="isLoading || loginForm.invalid"
            class="group relative w-full cursor-pointer flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-arabic-green hover:bg-arabic-green-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-arabic-green disabled:opacity-70"
          >
            <span class="absolute left-0 inset-y-0 flex items-center pl-3">
              <svg
                *ngIf="!isLoading"
                class="h-5 w-5 text-arabic-green-light group-hover:text-arabic-white"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <svg
                *ngIf="isLoading"
                class="animate-spin -ml-1 mr-3 h-5 w-5 text-arabic-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                ></circle>
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
            </span>
            <span translate="LOGIN.BUTTON"></span>
          </button>
        </div>

        <!-- Error Message Display -->
        <div *ngIf="errorMessage" class="mt-3 text-center">
          <p class="text-sm text-red-600">{{ errorMessage }}</p>
        </div>
      </form>
    </div>

    <!-- Image Section -->
    <div class="hidden md:block md:w-1/2 bg-indigo-50 dark:bg-gray-700">
      <div class="h-full flex items-center justify-center p-8">
        <img
          class="max-w-full max-h-full object-cover dark:hidden"
          src="assets/logo/Logo.svg"
          alt="Workspace"
        />
        <img
          class="max-w-full max-h-full object-cover hidden dark:block"
          src="assets/logo/Logo-white.svg"
          alt="Workspace"
        />
      </div>
    </div>
  </div>
</div>
